module.exports = __webpack_public_path__ + "static/img/bg_blur02.88b9bfce.jpg";